import axios from 'axios';

const API_URL = 'https://dacmethodbackend.herokuapp.com/api/auth';

class AuthService {
    login(firstname, password){
        return axios.post(API_URL + '/signin', {firstname, password})
                    .then(res=>{
                        if(res.data.accessToken){localStorage.setItem('user', JSON.stringify(res.data))};
                        return res.data;
                    });
    }
    logout(){
        localStorage.removeItem('user');
    }

    register(useremail,firstname, lastname, password,usercode){
        return axios.post(API_URL+'/signup',{useremail,firstname, lastname, password,usercode});
    }

    getCurrentUser(){
        return JSON.parse(localStorage.getItem('user'));
    }


}

export default new AuthService();
